import type { AuthUser } from '../api/client';
import { panelPath } from '../config/paths';
import { getOnboardingResumePath } from './samples';

/** Where a logged-in user should land after auth or a mid-flow redirect. */
export function postAuthPath(user: AuthUser, fallbackPanel = panelPath('/')): string {
  if (!user.onboardingCompleted) return getOnboardingResumePath(user.id);
  if (!user.hasActiveAccess) return '/select-plan';
  return fallbackPanel;
}
